var project = require('../../settings');
var utils = require('./modules/utils');

/* Event Handlers  */
(function ($, $PB) {
    var scroll_offset = -50;
    var scroll_speed = 1000;

    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        utils.equalHeight('.equal');
        $(window).trigger('resize').trigger('scroll');

        setInterval(function() {
            jQuery(window).trigger('resize').trigger('scroll');
        }, 1000);
    });

    $("#menu-wrapper").mmenu(
        {
            "navbar": {
                "title": mmtitle,
            },
            "navbars": [
                {
                    "position": "bottom",
                    "content": [
                        "searchfield"
                    ]
                }
            ],
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ],
            "searchfield": {
                "search": false,
            },
        }, {
            "searchfield": {
                "form": {
                    "method": 'GET',
                    "action": homeurl
                },
                "input": {
                    "name": 's'
                }
            }
        }
    );

    $( document ).ready(function() {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
        $('.builder-component-image-grid .block-wrap').show();
    });

    var $header = $('header');
    var $clone = $header.clone().addClass("clone").removeClass('main');
    $header.before($clone);

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        var $target = $header.height();

        if (scroll >= $target) {
            $clone.addClass('sticky');
            $header.addClass('u-hidden');
        } else if(scroll <= $target) {
            $clone.removeClass('sticky');
            $header.removeClass('u-hidden');
        }
    });

    $PB('.builder-component-ticker-counter').on('builderAnimationStart', function() {
        var $this = $(this),
            $number = $this.find('.single-counter .number'),
            countTo = $number.attr('data-count'),
            delay = $this.attr('data-animation-delay') * 1000;

        setTimeout(function () {
            $({
                countNum: 0
            }).animate({
                    countNum: countTo
                },

                {
                    duration: 3000,
                    easing: 'linear',
                    step: function() {
                        $number.text(commaSeparateNumber(Math.floor(this.countNum)));
                    },
                    complete: function() {
                        $number.text(commaSeparateNumber(this.countNum));
                    }
                }
            );
        }, delay);
    });

    function commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    $('.product-tabs-column ul.tabs-wrap li:first-child').addClass('open');
    $('.tab-outer-wrap .tab-content:first-child').addClass('open');

    $('.product-tabs-column ul.tabs-wrap li').on('click', function(){
        var $tab_id = $(this).attr('data-tab');

        $('.product-tabs-column ul.tabs-wrap li').removeClass('open');
        $('.tab-content').removeClass('open');

        $(this).addClass('open');
        $("#"+$tab_id).addClass('open');

    });

    $('.builder-layout-half-block .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.builder-layout-rollover-section .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.sidebar-wrap .category .cat-link').on('click', function (e) {
        e.preventDefault();
    });

    $('.sidebar-wrap .category a').on('click', function () {
        var $category = $(this);

        $category.parent().toggleClass('open');
        $category.toggleClass('active');

        $category.parent().find('.sub-menu').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });


    var viewportWidth = window.innerWidth;

    if (viewportWidth < 991) {
        $('.sidebar-wrap .top-wrap').on('click', function () {
            var $category = $(this);

            $category.toggleClass('active');

            $category.parent().find('.menu-wrap').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });
    }

    $('.custom-sidebar .single-link:first-child').addClass('open');
    $('.custom-sidebar .single-link:first-child .link').addClass('active');

    $('.custom-sidebar .single-link .link').on('click', function (e) {
        e.preventDefault();

        var $category = $(this);

        $category.parent().toggleClass('open');
        $category.toggleClass('active');

        $category.parent().find('.sub-menu').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });

    $('.single-accordion .accordion-header').on('click', function() {
        var $column = $(this).parent();
        $column.toggleClass('open');
        $column.find('.accordion-inner').slideToggle({
            duration: 250,
            progress: function() {
                $(window).trigger('resize');
            }
        });
    });

    $('.builder-layout-tabbed-content .tab-column ul.tabs-wrap li').on('click', function(){
        var $tab_id = $(this).attr('data-tab');

        $('.tab-column ul.tabs-wrap li').addClass('inactive');

        $(this).removeClass('inactive');

        $('.tab-content').removeClass('open');

        $("#"+$tab_id).addClass('open');

    });

    if(location.hash) {
        $(window).load(function() {
            utils.ScrollToHash(location.hash, null, scroll_offset, scroll_speed);
        });
    }

    $(window).on('hashchange', function(e) {
        if(location.hash) {
            if(!utils.ScrollToHash(location.hash, null, scroll_offset, scroll_speed)) {
                e.preventDefault();
            }
        }
    });

    if (viewportWidth < 991) {
        $('.custom-sidebar .top-wrap').on('click', function () {
            var $category = $(this);

            //$category.parent().toggleClass('open');
            $category.toggleClass('active');

            $category.parent().find('.menu-wrap').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });
    }

    $('nav.primary .menu-top-level-item').on('mouseenter', function() {
        $(this).parents('.menu').find('.menu-top-level-item').removeClass('active');
        $(this).removeClass('fadeout').addClass('active');
    });

    $('nav.primary .menu-top-level-item').on('mouseleave', function() {
        var $this = $(this);

        setTimeout(function() {
            if(!$this.is(':hover')) {
                $this.addClass('fadeout');
            }
        }, 300);

        setTimeout(function() {
            if(!$this.is(':hover')) {
                $this.removeClass('active');
                $this.removeClass('fadeout');
            }
        }, 600);
    });

    //Header top spacer
    var adjustHeader = function () {
        var padding = $('header.main').outerHeight() + ($('header.main').outerWidth() * .04);
        // Builder banners
        if(!$('div').hasClass('builder-sidebar-template')){
            $('.builder-section:first').css('padding-top', padding).css('padding-bottom', '4%');
        }

        // Title Banner
        $('.title-banner').css('padding-top', padding).css('padding-bottom', '4%');

        // News Events
        $('.top-banner').css('padding-top', padding).css('padding-bottom', '4%');

        // Products Banner
        $('.products-banner').css('padding-top', padding).css('padding-bottom', '4%');

        // Sidebar Template Banner
        $('.heading-banner').css('padding-top', padding).css('padding-bottom', '4%');
    };

    $(window).on('resize load', adjustHeader);
    $(document).on('ready', adjustHeader);

})(jQuery, KMDGPB.jQuery);